
//to change accordingly to the dematholding from falconalgo document..
//this will show funds table for now..

import React, { useEffect, useState, useMemo } from "react";
import { Table, InputGroup, FormControl, Spinner } from "react-bootstrap";
import { useTable, useFilters, useGlobalFilter, useSortBy } from "react-table";
import tw from "twin.macro";
import axios from 'axios';

const Container = tw.div`container bg-white p-4 rounded border border-gray-200 flex-1`;
const Title = tw.h1`text-xl font-bold text-blue-600 mb-2 text-center`;
const TableWrapper = tw.div`mt-3 overflow-auto`;

export default function DematHoldings() {
  const [fundsData, setFundsData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchFundsData = async () => {
      setLoading(true);
      try {
        const response = await axios.get('https://falcon-algo.onrender.com/api/demat', { withCredentials: true });
        if (response.data.Success) {
          const fundsData = [response.data.Success];
          setFundsData(fundsData);
        } else {
          console.error('Unexpected response format:', response.data);
        }
      } catch (error) {
        console.error('Error fetching funds data', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFundsData();
  }, []);

  const data = useMemo(() => fundsData, [fundsData]);

  const columns = useMemo(
    () => [
      { Header: "Bank Account", accessor: "bank_account" },
      { Header: "Total Bank Balance", accessor: "total_bank_balance" },
      { Header: "Allocated Equity", accessor: "allocated_equity" },
      { Header: "Allocated FNO", accessor: "allocated_fno" },
      { Header: "Block by Trade Equity", accessor: "block_by_trade_equity" },
      { Header: "Block by Trade FNO", accessor: "block_by_trade_fno" },
      { Header: "Block by Trade Balance", accessor: "block_by_trade_balance" },
      { Header: "Unallocated Balance", accessor: "unallocated_balance" },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    setGlobalFilter,
    state,
  } = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useGlobalFilter,
    useSortBy
  );

  const { globalFilter } = state;

  return (
    <Container>
      <Title>Funds</Title>
      {loading ? (
        <div tw="flex justify-center items-center ">
          <Spinner animation="border" role="status">
          </Spinner>
          
            <span className="sr-only" tw="text-gray-700">   Loading...</span>
        </div>
      ) : (
        <>
          <InputGroup className="my-3">
            <FormControl
              value={globalFilter || ""}
              onChange={(e) => setGlobalFilter(e.target.value)}
              placeholder="Search..."
            />
          </InputGroup>
          <TableWrapper>
            <Table striped bordered hover responsive {...getTableProps()} style={{ fontSize: '12px' }}>
              <thead>
                {headerGroups.map(headerGroup => (
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {headerGroup.headers.map(column => (
                      <th {...column.getHeaderProps()} style={{ textAlign: 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                          <div>{column.render('Header')}</div>
                          {column.canSort && (
                            <div {...column.getSortByToggleProps()} style={{ cursor: 'pointer' }}>
                              {column.isSorted ? (
                                column.isSortedDesc ? '🔽' : '🔼'
                              ) : (
                                <>
                                  <span>🔼</span>
                                  <span>🔽</span>
                                </>
                              )}
                            </div>
                          )}
                        </div>
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map(row => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()}>
                      {row.cells.map(cell => (
                        <td {...cell.getCellProps()}>{cell.render('Cell')}</td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </TableWrapper>
        </>
      )}
    </Container>
  );
}
